// extracted by mini-css-extract-plugin
module.exports = {"googleBtn":"style-module__googleBtn___0oWmV","googleIcon":"style-module__googleIcon___tBgvd"};